import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button, Divider, HStack, Heading, Icon, IconButton, Modal as ChakraModal, ModalBody, ModalContent, ModalOverlay, Stack, ModalFooter } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faClose } from '@fortawesome/free-solid-svg-icons';
import AuthProviderSteps from './AuthProviderSteps';
import { FormattedMessage, useIntl } from 'react-intl';
export default function OnboardingModal(param) {
    var channel = param.channel, isOpen = param.isOpen, onClose = param.onClose;
    var intl = useIntl();
    return /*#__PURE__*/ _jsxs(ChakraModal, {
        isOpen: isOpen,
        onClose: onClose,
        isCentered: true,
        size: "lg",
        children: [
            /*#__PURE__*/ _jsx(ModalOverlay, {}),
            /*#__PURE__*/ _jsx(ModalContent, {
                bgColor: "backgroundPrimary",
                children: /*#__PURE__*/ _jsxs(ModalBody, {
                    p: 0,
                    children: [
                        /*#__PURE__*/ _jsxs(HStack, {
                            spacing: 4,
                            alignItems: "center",
                            px: 6,
                            py: 4,
                            children: [
                                /*#__PURE__*/ _jsx(Icon, {
                                    as: FontAwesomeIcon,
                                    icon: faCheckCircle,
                                    color: "success"
                                }),
                                /*#__PURE__*/ _jsx(Heading, {
                                    size: "md",
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "LCNN84",
                                        defaultMessage: "Setting up Nightbot"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(IconButton, {
                                    marginLeft: "auto",
                                    variant: "ghost",
                                    size: "sm",
                                    "aria-label": intl.formatMessage({
                                        id: "rbrahO",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Close"
                                            }
                                        ]
                                    }),
                                    icon: /*#__PURE__*/ _jsx(Icon, {
                                        as: FontAwesomeIcon,
                                        icon: faClose
                                    }),
                                    onClick: onClose
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Divider, {
                            borderColor: "borderSecondary"
                        }),
                        /*#__PURE__*/ _jsx(Stack, {
                            spacing: 4,
                            p: 6,
                            children: /*#__PURE__*/ _jsx(AuthProviderSteps, {
                                channel: channel
                            })
                        }),
                        /*#__PURE__*/ _jsx(Divider, {
                            borderColor: "borderSecondary"
                        }),
                        /*#__PURE__*/ _jsx(ModalFooter, {
                            padding: 6,
                            children: /*#__PURE__*/ _jsx(Button, {
                                width: "auto",
                                onClick: onClose,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "rbrahO",
                                    defaultMessage: "Close"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
